import { createAction, props } from '@ngrx/store';

/**
 * set window width
 */
export const setWindowWidth = createAction('[window-resize] set window width', props<{ windowWidth: number }>());
